import {Component, OnInit} from '@angular/core';
import {LoadingService} from '../../_services/loading.service';
import {LocalStorageService, UserService} from '../../_services';
import {environment} from '../../../environments/environment';
import {MenuOptionsModalPage} from '../menu-options-modal/menu-options-modal-page';
import {ModalController} from '@ionic/angular';
import {ReadMoreComponent} from '../../modules/user/projects/invisible-city/read-more/read-more.component';
import {IntroReadMoreComponent} from '../../modules/intro/intro-read-more.component';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastService} from '../../_services/toast.service';

@Component({
  selector: 'app-landing-preview',
  templateUrl: './landing-preview.component.html',
  styleUrls: ['./landing-preview.component.scss']
})
export class LandingPreviewComponent implements OnInit {
  backgroundImage = '/assets/img/png/mapimo-landing.webp';
  emotion = '';
  selectedProjectObj: any;
  selectedProject = 'All projects';
  projectType = '';
  projectList: any[] = [];
  server = environment.server + '/public';

  constructor(public loadingService: LoadingService,
              private router: Router,
              private localStorage: LocalStorageService,
              private toast: ToastService,
              private activatedRoute: ActivatedRoute,
              private modalController: ModalController,
              private userService: UserService,) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.hasOwnProperty('projectType')) {
        this.projectType = params.projectType;
      }
    });
  }

  ngOnInit(): void {
    this.getProjectData();
  }

  getProjectData() {
    this.loadingService.show();
    this.userService.getProjectData()
      .subscribe({
        next: (value) => {
          this.loadingService.hide();
          this.projectList = value;
          this.localStorage.set('project_list', value);
          if (this.projectType) {
            const selectedProjectObj = this.projectList.find(obj => obj.ref === this.projectType);
            this.dataSet(selectedProjectObj);
          } else {
            this.selectedProjectObj = value[0];
          }
          this.loadingService.hide();
        },
        error: (err) => {
          this.loadingService.hide();
          console.error(err, 'error');
        }
      });
  }

  dataSet(obj) {
    this.selectedProject = obj.name;
    this.selectedProjectObj = obj;
    console.log(this.selectedProjectObj);
    this.backgroundImage = obj.name === 'All projects' ? '/assets/img/png/mapimo-landing.webp' : this.server + obj.coverImage;
  }

  async openMenu() {
    const modal = await this.modalController.create({
      component: MenuOptionsModalPage,
      componentProps: {
        projectType: this.selectedProjectObj
      },
      cssClass: 'custom-menu',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  readMore() {
    if (this.selectedProject === 'All projects') {
      this.icReadMore();
    } else {
      this.projectReadMore();
    }
  }

  async projectReadMore() {
    const modal = await this.modalController.create({
      component: ReadMoreComponent,
      componentProps: {
        projectType: this.selectedProjectObj.ref
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  async icReadMore() {
    const modal = await this.modalController.create({
      component: IntroReadMoreComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  navigateToMap() {
    console.log(this.selectedProjectObj);
    console.log(this.selectedProjectObj.ref);
    this.localStorage.set('selected_project', this.selectedProjectObj);
    this.localStorage.set('projectType', this.selectedProjectObj.ref);
    sessionStorage.removeItem('filter_data');
    sessionStorage.removeItem('filter_emotion');
    sessionStorage.removeItem('filter_gender');
    sessionStorage.removeItem('filter_category');
    sessionStorage.removeItem('filter_organisationSize');
    sessionStorage.removeItem('filter_operationTime');
    this.router.navigate(['/map'], {queryParams: {projectType: this.selectedProjectObj.ref}});
  }

  shareLink() {
    this.toast.display('Link copied');
    navigator.clipboard.writeText(environment.server);
  }
}
